import { render, staticRenderFns } from "./FTPPdRes.vue?vue&type=template&id=1a5dd647&scoped=true&"
import script from "./FTPPdRes.vue?vue&type=script&lang=js&"
export * from "./FTPPdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5dd647",
  null
  
)

export default component.exports